
/**
 * Created by xiehan on 2019/01/15
 */
import Logic from '../logic-base'

const resApplicationBiz = new Logic()

resApplicationBiz.getAll = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.getAll,
    data: data
  })
}

resApplicationBiz.getSelfInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.getSelfInfo,
    data: data
  })
}

resApplicationBiz.findUserByGroupId = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.findUserByGroupId,
    data: data
  })
}

resApplicationBiz.findCcpeopleList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.findUser,
    data: data
  })
}

resApplicationBiz.closeOrder = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.closeOrder,
    data: data
  })
}

resApplicationBiz.startProcess = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.startProcess,
    data: data
  })
}

resApplicationBiz.findUserByTask = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.findUserByTask,
    data: data
  })
}

resApplicationBiz.submitApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.submitApply,
    data: data
  })
}

resApplicationBiz.submitPaasApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.submitPaasApply,
    data: data
  })
}

resApplicationBiz.submitBusinessOnline = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.submitBusinessOnline,
    data: data
  })
}

resApplicationBiz.submitShutdownApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.submitShutdownApply,
    data: data
  })
}

resApplicationBiz.findAllVersion = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.findAllVersion,
    data: data
  })
}

resApplicationBiz.submitCommonApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.submitCommonApply,
    data: data
  })
}

resApplicationBiz.submitPermissionApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.submitPermissionApply,
    data: data
  })
}

resApplicationBiz.submitCloseApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.submitCloseApply,
    data: data
  })
}

resApplicationBiz.submitRevokeApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.submitRevokeApply,
    data: data
  })
}

export default resApplicationBiz
